import { getIntegratorApi, getIntegratorApiFullscreenIframeWindow } from './klarnaIntegratorApi'

export function getFullscreenWindow(win = window) {
  if (getIntegratorApi(win)) {
    return getIntegratorApiFullscreenIframeWindow(win)
  } else {
    return win
  }
}
